import React from "react";
import Arrow_up_small from "../images/Arrow_up_small.svg";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

const LeftRightComboWithList = ({
  mainTitle,
  subTitle,
  image,
  buttonText,
  index,
  topBtnText,
  topSmallImg,
  buttonTextNavigate,
  topImgBackColor,
  isHomePage,
  pageTitle,
  list,
  section,
}) => {
  const navigate = useNavigate();

  const findOddEven = index % 2 == 0;
  return (
    <div className="md:container md:mx-auto">
      <div className="grid sm:grid-cols-1 md:grid-cols-2 sm:gap-[0%] md:gap-[14%]  my-[12px] sm:my-[20px] lg:my-[70px] mx-[0px] sm:mx-[16px] 3xl:my-[100px]">
        <div
          id={section}
          className={`flex flex-col justify-between py-[10px] ${findOddEven ? "sm:order-1 md:order-1" : "sm:order-1 md:order-2"
            } px-[15px] sm:px-[30px] md:px-[0px]`}
        >
          <div>
            {
              topSmallImg && (
                // <div className={`bg-[#${topImgBackColor}] p-[8px] w-fit rounded-[16px] border`}>
                <img
                  draggable="false"
                  src={topSmallImg}
                  className="xl:w-[60px] 3xl:w-[80px]"
                />
              )
              // </div>
            }
            {topBtnText && (
              <button
                className="topButtonOurServices text-[14px] sm:text-[18px] text-[#3359D3] font-[700]"
                onClick={() => navigate(buttonTextNavigate)}
              >
                {topBtnText}
              </button>
            )}
            <p className="sora text-[16px] sm:text-[20px] leadeing-[28px]  sm:leading-[42px] sm:text-[28px] 3xl:text-[34px] font-[700]  text-[#000] pt-[5px] sm:pt-[16px]">
              {mainTitle}
            </p>
            <p className="sora text-[12px] sm:text-[14px] 3xl:text-[18px] font-[400] leading-[22px] sm:leading-[26px] text-[#444] pt-[5px] sm:pt-[10px]">
              {subTitle}
              <ul className="list-square" style={{ marginLeft: "20px" }}>
                {list.map((item, index) => {
                  return <li key={index} className="sora">{item}</li>;
                })}
              </ul>
            </p>
          </div>
          <div className="pt-[10px] sm:pt-[10px] lg:pt-[20px]">
            <div
              className="getStartedBtnOuter"
              onClick={() =>
                navigate(
                  pageTitle && pageTitle === "company-overview"
                    ? buttonTextNavigate
                    : "/contact-us"
                )
              }
            >
              <Button className="NunitoSans getStartedBtn">
                {buttonText}
                <img
                  draggable="false"
                  src={Arrow_up_small}
                  className="w-[9px] sm:w-[12px] ml-[4px]"
                  alt="Arrow_up_small"
                />
              </Button>
            </div>
          </div>
        </div>
        <div
          className={`flex ${findOddEven
              ? "sm:order-1 sm:justify-center md:order-2 md:justify-end"
              : "sm:order-1 sm:justify-center md:order-1 md:justify-start"
            } px-[15px] sm:px-[30px] md:px-[0px]`}
        >
          <img
            draggable="false"
            src={image}
            className="h-[200px]  sm:h-[300px] md:h-[auto] w-[100%] sm:w-[auto]  3xl:w-[600px] rounded-[10px] object-contain "
            alt="image"
          />
        </div>
      </div>
    </div>
  );
};

export default LeftRightComboWithList;
